import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Webside/layout";
import Aboutus from "./components/layout/Webside/About";
import ServicesPage from "./components/layout/Webside/Services";
import ContactPage from "./components/layout/Webside/Contact";
import Pressrelease from "./components/layout/Webside/Pressrelease";
import Dashboard from "./pages/Dashboard";
import UsersTable from "./components/layout/Dashboard/Users/Users";
import LoginPage from "./components/layout/Login";


import PrivacyPolicy from "./components/layout/Webside/privacypolicy";
import Cancellationpolicy from "./components/layout/Webside/Cancellationpolicy";
import TermsAndConditions from "./components/layout/Webside/TermsAndConditions";
import ShippingPolicy from "./components/layout/Webside/Shippingpolicy";
import RefundPolicy from "./components/layout/Webside/Refundpolicy";
import OurCertifications from "./components/layout/Webside/OurCertifications";
import WhyChooseUs from "./components/layout/Webside/WhyChooseUs";




// Routes mein add k
function App() {
  return (
    <div style={{ fontFamily: "Quicksand" }}>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/About" element={<Aboutus />} />
          <Route path="/Services" element={<ServicesPage />} />
          <Route path="/Contact" element={<ContactPage />} />
          <Route path="/Pressrelease" element={<Pressrelease />} />
          <Route path="/UsersTable" element={<UsersTable />} />
            <Route path="/Login" element={<LoginPage/>} />
         
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy/>} />
            <Route path="/ShippingPolicy" element={<ShippingPolicy/>} />
            <Route path="/TermsAndConditions" element={<TermsAndConditions/>} />
            <Route path="/Cancellationpolicy" element={<Cancellationpolicy/>} />
         
         
            <Route path="/RefundPolicy" element={<RefundPolicy/>} />
            <Route path="/OurCertifications" element={<OurCertifications/>} />
            <Route path="/WhyChooseUs" element={<WhyChooseUs/>} />
            
       
          
        </Routes>
      </Router>
    </div>
  );
}

export default App;
